<script lang="ts" setup>
import { ref, watch, watchEffect } from 'vue';
import { usePrinterStore } from '@/stores/printer';
import { INode } from '@posx/core';
import { Add, Done } from '@xpos/icons-svg';
import { useI18n } from 'vue-i18n';
import { notify } from '@/utils/notification';

const { t } = useI18n();
const $emit = defineEmits(['change', 'update:modelValue', 'close']);
const $props = defineProps({
  modelValue: {
    type: Boolean,
  },
  data: {
    type: String,
    defualt: '',
  },
});

const printerStore = usePrinterStore();
const nodeInfo = ref<INode>();
watchEffect(async () => {
  if ($props.modelValue) {
    try {
      const result = await printerStore.getUnpairedNode();
      if (result?.data) {
        nodeInfo.value = result?.data;
      } else {
        notify.error(result?.error);
        handleClose();
      }
    } catch (e) {
      handleClose();
    }
  }
});

const visible = ref($props.modelValue);
watch(
  () => $props.modelValue,
  (newVal: boolean) => {
    visible.value = newVal;
  },
);

const handleClose = () => {
  $emit('change', false);
  $emit('update:modelValue', false);
  $emit('close', false);
};

const handleConfirm = async () => {
  await printerStore.pairNode(nodeInfo.value?.uid!);
};
</script>

<template>
  <x-dialog
    v-model="visible"
    width="770px"
    :title="t('printer.confirmTitle')"
    :before-close="handleClose"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="w-[355px] flex flex-col justify-between">
      <div>
        <p class="text-[20px]">
          {{ t('printer.confirmContent', [nodeInfo?.machine_name]) }}
        </p>
        <div class="flex w-full justify-center mt-16">
          <img src="/icon_printer.png" alt="" class="w-[100px]" />
        </div>
      </div>
      <el-button color="#80BA5C" class="w-full text-white" @click="handleConfirm"
        ><el-icon size="20" color="#fff" class=""><Done /></el-icon
        ><span class="text-white align-super">{{ t('printer.confirm') }}</span></el-button
      >
    </div>
  </x-dialog>
</template>

